import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const AFFILIATE_VALID_API_URL = BASE_API_URL + 'affiliate/code-valid';

/**
 * Local fork of @curbnturf/affiliate's ReferenceCodeService — same single
 * endpoint, sourced from cnt-landing's own BASE_API_URL instead of
 * @curbnturf/entities'.
 */
@Injectable({ providedIn: 'root' })
export class AffiliateApiService {
  private readonly http = inject(HttpClient);

  validateAffiliateRef(desiredRefCode: string): Observable<string> {
    return this.http.get<string>(`${AFFILIATE_VALID_API_URL}/${desiredRefCode}`);
  }
}
